import Button from './src/button.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToButton: SFCWithInstall<typeof Button> = withInstall(Button)

export default ToButton
export * from './src/instance'

export type { ButtonInstance } from './src/instance'
